import { Box, Button, Divider, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CustomDialog } from "../../../../global/components";
import urls from "../../../../global/constants/UrlConstants";
import {
  handleErrorMessage,
  openSuccessNotification,
} from "../../../../helpers/methods";
import { setIsVedazUserAction } from "../../../../redux/authSlice";
import history from "../../../../utils/history";
import { useAppDispatch } from "../../../../utils/hooks";
import { getRelativeFontSize } from "../../../../utils/styles";
import consentFormDialogStyles from "./ConsentFormDialog.styles";
import { migrateUserMethod } from "./ConsentFormDialogService";

interface CustomProps {
  setIsLoading: Function;
  handleClose: Function;
  open: boolean;
  fromSettings?: boolean;
}

const ConsentFormDialog = (props: CustomProps) => {
  const classes = consentFormDialogStyles;
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const handleMigrateUser = async (consent: boolean) => {
    try {
      props.setIsLoading(true);
      const response = await migrateUserMethod(consent);
      dispatch(setIsVedazUserAction({ isVedazUser: consent }));
      openSuccessNotification(response.message);
      props.handleClose();
      !props.fromSettings && consent && history.push(urls.vedazTalkViewPath);
      props.setIsLoading(false);
    } catch (error: any) {
      props.setIsLoading(false);
      handleErrorMessage(error);
    }
  };

  const dialogHeaderContent = () => {
    return (
      <Stack direction={"column"} alignItems={"center"} spacing={2} pt={5}>
        <Typography sx={classes.modalHeader} px={2}>
          {t("consentFormHeader")}
        </Typography>

        <Divider
          sx={{
            border: "1px solid #222222",
            width: "50%",
            height: "0px",
          }}
        />
      </Stack>
    );
  };

  const dialogBodyContent = () => {
    return (
      <Stack direction={"column"} pb={5} spacing={2} sx={classes.dialogContent}>
        <Typography
          sx={{
            ...classes.lightFont,
            fontSize: getRelativeFontSize(5),
          }}
          pt={2}
        >
          {t("consentFormContent1")}
        </Typography>
        <Typography
          sx={{
            ...classes.lightFont,
            fontSize: getRelativeFontSize(5),
          }}
          pt={2}
        >
          {t("consentFormContent2")}
        </Typography>

        <Stack
          direction={{ sm: "row", xs: "column" }}
          spacing={2}
          alignSelf={"center"}
        >
          <Button
            onClick={() => handleMigrateUser(false)}
            sx={classes.cancelBtn}
          >
            <Box sx={classes.cancelBtnBox}>
              <Typography className="btnText"> {t("noConsent")}</Typography>
            </Box>
          </Button>
          <Button
            onClick={() => handleMigrateUser(true)}
            sx={classes.logoutBtn}
          >
            <Typography className="btnText"> {t("yesConsent")}</Typography>
          </Button>
        </Stack>
      </Stack>
    );
  };
  const getConsentFormDialog = () => {
    return (
      <CustomDialog
        width="600px"
        borderRadius="10px"
        isDialogOpen={props.open}
        closable={true}
        closeButtonVisibility={true}
        handleDialogClose={() => props.handleClose()}
        dialogHeaderContent={dialogHeaderContent()}
        dialogBodyContent={dialogBodyContent()}
      />
    );
  };
  return getConsentFormDialog();
};

export default ConsentFormDialog;
